// AUTO-GENERATED FILE. Do not edit.
export interface BuildInfo {
  version: string;
  build: string;
  commit: string;
  branch: string;
  date: string;
  environment: string;
  /** Version lisible pour les utilisateurs, ex: "v2.1.0 #42" */
  displayVersion: string;
  /** Version technique complète, ex: "2.1.0+42.a3f8b2c" */
  fullVersion: string;
}

export const BUILD_INFO: BuildInfo = {
  "version": "2.1.57",
  "build": "179",
  "commit": "9b2ec8a",
  "branch": "main",
  "date": "2026-11-04T13:33:19.280Z",
  "environment": "production",
  "displayVersion": "v2.1.57 #179",
  "fullVersion": "2.1.57+179.9b2ec8a"
} as const;
